export enum ColorTheme {
  Dark = 'Dark',
  Light = 'Light',
}
